/**
 * BpRulesCard — iter1057 — правила за правилно мерене на кръвното налягане
 * (както правилата за измерване на хормоните в ендокринния слой).
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/App";
import { ChevronDown, Ruler } from "lucide-react";

export const BpRulesCard = ({ isDark }) => {
  const { API } = useAuth();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/cardio/measurement-rules`)
      .then(({ data }) => setData(data)).catch(() => setData(null));
  }, [API]);

  const card = isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200";
  const box = isDark ? "bg-slate-800/50" : "bg-slate-100";
  if (!data) return null;

  return (
    <div className={`p-5 rounded-2xl border ${card}`} data-testid="bp-rules-card">
      <button onClick={() => setExpanded(!expanded)} className="w-full text-left flex items-center gap-2"
              data-testid="bp-rules-toggle">
        <Ruler className="w-4 h-4 text-red-500" />
        <h2 className="font-bold text-sm flex-1">Как се мери кръвното правилно</h2>
        <ChevronDown className={`w-4 h-4 opacity-50 shrink-0 transition-transform ${expanded ? "rotate-180" : ""}`} />
      </button>
      <p className="text-[11px] opacity-75 leading-relaxed mt-1">{data.intro_bg}</p>

      {expanded && (
        <div className="space-y-1.5 mt-3" data-testid="bp-rules-list">
          {data.rules.map((r) => (
            <div key={r.key} className={`rounded-xl overflow-hidden ${box}`}>
              <button onClick={() => setOpen(open === r.key ? null : r.key)}
                      className="w-full text-left p-2.5 flex items-center gap-2"
                      data-testid={`bp-rule-${r.key}`}>
                <span className="text-[11px] font-bold flex-1 min-w-0">{r.title_bg}</span>
                <ChevronDown className={`w-3 h-3 opacity-50 shrink-0 transition-transform ${open === r.key ? "rotate-180" : ""}`} />
              </button>
              {open === r.key && (
                <div className="px-2.5 pb-2.5 text-[11px] leading-relaxed opacity-85"
                     data-testid={`bp-rule-text-${r.key}`}>{r.text_bg}</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BpRulesCard;
